import { gql } from "@apollo/client";

export const GET_POPULAR_SERVICES = gql`
  query {
    getPopularService {
      data {
        id
        name
        category {
          id
          name
        }
      }
      errors {
        message
      }
    }
  }
`;

export const GET_CATEGORIES = gql`
  query (
    $order: String
    $field: String!
    $offset: Int!
    $limit: Int!
    $paranoid: Boolean!
    $serviceType: ServiceEnumType
  ) {
    getPaginatedCategories(
      order: $order
      field: $field
      offset: $offset
      limit: $limit
      paranoid: $paranoid
      serviceType: $serviceType
      isServicePublic: true
      isCategoryPublic: true
    ) {
      categories {
        id
        name
        serviceType
        services {
          id
          name
          isFeatured
        }
      }
      count
      errors {
        message
      }
    }
  }
`;

export const GET_SERVICE_BY_ID = gql`
  query ($id: Int!) {
    getPublicServiceById(id: $id) {
      data {
        id
        name
        type
        description
        popularService
        category {
          id
          name
        }
        isPublished
        criticalDeadline {
          from
          to
          value
        }
        notifyAfter
        suspensionHistory
        isFeatured
        isAttachmentAllowed
        fields {
          id
          name
          type
          isHidden
          inputFieldName
          multipleInputFieldName
          calenderLink
          ioType
          cluster
        }
        triggers {
          name
          calculationId
          target {
            actionType
            statusId
            templateId
          }
        }

        calculation {
          id
          name
          expression
          uid
        }
      }
      errors {
        message
      }
    }
  }
`;

export const GET_SERVICE_BY_SUB_SERVICE_TYPE = gql`
  query ($masterId: Int!, $serviceType: SubServiceEnumType!) {
    getServiceBySubServiceType(
      options: { masterId: $masterId, serviceType: $serviceType }
    ) {
      errors {
        message
      }
      data {
        id
        name
        fields {
          id
          name
          type
          cluster
          inputFieldName
          multipleInputFieldName
          isRequired
          ioType
        }
        clusters {
          name
          isRepeatable
        }
        criticalDeadline {
          from
          to
          value
        }
      }
    }
  }
`;
